/**
 * React Utils
 */

import * as React from 'react';

export function nl2br(str: string) {
  return str.split('\n').map((item, key) => <span key={key}>{item}<br /></span>);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/react.tsx